import styled from 'styled-components'

import { color as colorSite } from '../../config/siteConstants'
import { devices } from '../../config/constants'

export const Span = styled.span`
  strong {
    color: ${colorSite.light};
  }

  .btn {
    position: relative;
    top: 0;
    font-size: 1rem;
    padding: 0.3em 1em;
  }

  @media ${devices.tablet} {
    .btn {
      top: -0.5em;
    }
  }
`